// File: src/pages/Register/Register.jsx

import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "../../axios";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
  Link,
} from "@mui/material";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

function Register() {
  const [form, setForm] = useState({
    companyName: "",
    Mobile: "",
    Email: "",
    userName: "",
    password: "",
  });

  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    try {
      const response = await axios.post("/auth/register-company", form);

      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);
        setMessage("✅ تم إنشاء المنشأة وحساب المسؤول بنجاح! جاري تحويلك...");
        setForm({
          companyName: "",
          Mobile: "",
          Email: "",
          userName: "",
          password: "",
        });
        
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);

      } else {
        setIsSuccess(false);
        setMessage(`❌ فشل التسجيل: ${response.data}`);
      }
    } catch (error) {
      setIsSuccess(false);
      const errorMsg = error.response?.data || error.message || "خطأ في الاتصال بالسيرفر";
      setMessage(`❌ ${errorMsg}`);
    }
  };

  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center',
        // خلفية ناعمة جداً مقتبسة من أحدث واجهات الـ SaaS الاحترافية
        background: 'radial-gradient(circle at 80% 20%, rgba(79, 70, 229, 0.05) 0%, transparent 50%), radial-gradient(circle at 10% 80%, rgba(16, 185, 129, 0.04) 0%, transparent 40%), #f8fafc',
        fontFamily: 'Alexandria',
        px: 2,
        py: 4
      }}
    >
      <Container maxWidth="sm" sx={{ p: 0 }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, sm: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: '32px', // حواف دائرية ناعمة جداً ومتناسقة
            width: '100%',
            backgroundColor: '#ffffff',
            border: '1px solid rgba(226, 232, 240, 0.8)',
            boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.04)'
          }}
        >
          {/* أيقونة الهيدر المحدثة بلمسة كرت ناعم */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '20px',
              backgroundColor: 'rgba(79, 70, 229, 0.08)',
              color: '#4F46E5',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2.5
            }}
          >
            <AppRegistrationIcon sx={{ fontSize: 32 }} />
          </Box>

          {/* عنوان الواجهة مع التدرج اللوني البريميوم */}
          <Typography 
            component="h1" 
            variant="h5" 
            sx={{ 
              mb: 1, 
              fontWeight: 800,
              background: 'linear-gradient(90deg, #4F46E5 0%, #10B981 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: { xs: '1.4rem', sm: '1.6rem' }
            }}
          >
            تسجيل منشأة جديدة
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontWeight: 500, textAlign: 'center' }}>
            ابدأ بتهيئة بيئة العمل الخاصة بمؤسستك وإصدار الفواتير الإلكترونية متوافقة ZATCA.
          </Typography>

          {message && (
            <Alert 
              severity={isSuccess ? "success" : "error"} 
              sx={{ 
                width: "100%", 
                mb: 3, 
                borderRadius: '14px', 
                fontWeight: 600,
                fontSize: '0.85rem'
              }}
            >
              {message}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              fullWidth
              label="اسم المنشأة / الشركة"
              name="companyName"
              value={form.companyName}
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{ sx: { borderRadius: '14px' } }}
              sx={{ mb: 2.5 }}
            />
            
            <TextField
              fullWidth
              label="رقم الجوال"
              name="Mobile"
              value={form.Mobile}
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{ sx: { borderRadius: '14px' } }}
              sx={{ mb: 2.5 }}
            />
            
            <TextField
              fullWidth
              label="البريد الإلكتروني للشركة"
              name="Email"
              type="email"
              value={form.Email}
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{ sx: { borderRadius: '14px' } }}
              sx={{ mb: 2.5 }}
            />
            
            <TextField
              fullWidth
              label="اسم مستخدم مدير النظام"
              name="userName"
              value={form.userName}
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{ sx: { borderRadius: '14px' } }}
              sx={{ mb: 2.5 }}
            />
            
            <TextField
              fullWidth
              label="كلمة المرور"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              variant="outlined"
              InputProps={{ sx: { borderRadius: '14px' } }}
              sx={{ mb: 4 }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ 
                py: 1.8,
                fontSize: '1rem',
                fontWeight: 700,
                mb: 3,
                borderRadius: '14px',
                backgroundColor: '#4F46E5',
                boxShadow: '0 10px 15px -3px rgba(79, 70, 229, 0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: '#4338CA',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 20px 25px -5px rgba(79, 70, 229, 0.3)'
                },
                '&:active': {
                  transform: 'translateY(0px)'
                }
              }}
            >
              إنشاء الحساب وبدء الفترة التجريبية
            </Button>

            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                لديك منشأة مسجلة بالفعل؟{" "}
                <Link 
                  component={RouterLink} 
                  to="/login" 
                  sx={{ 
                    color: '#4F46E5',
                    fontWeight: 700, 
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' } 
                  }}
                >
                  تسجيل الدخول للمنصة
                </Link>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default Register;